
let viewers = {};
const canvas_pro = document.getElementById('imageCanvas');
const ctx_pro = canvas_pro.getContext('2d');
let animationSpeedFactor = 0.8;
let viewer360SpeedFactor = 0.9;
let activeViewer = null;
let activeFolderIndex = 0;
let currentIndex_canvas = 0;
let isDragging_canvas = false;
let startX_canvas = 0;
let startTouchX_canvas = 0;
let accumulatedDrag = 0;
let autoPlayDirection = 0;
let isAutoPlaying = false;
let lastFrameTime = 0;
let isTransitionPlaying = false;
let currentTransitionSequence = null;
let currentTransitionIndex = 0;
let transitionStartTime = 0;
let currentSequenceKey = null;
let isReverseTransition = false;
let isLoopingAnimationPlaying = false;
let loopingSequenceKey = null;
let loopingStartTime = 0;
let activeMicroSequence = null;
let microSequenceIndex = 0;
let isSliderAutoPlaying = false;
let sliderAutoPlayStartTime = 0;
let sliderAutoPlayDirection = 1;
const sliderAutoPlayDuration = 1000;
const offscreenCanvas = document.createElement('canvas');
const offscreenCtx = offscreenCanvas.getContext('2d');
const hotspotDesign = document.getElementById('hotspot-design');
const hotspotDial = document.getElementById('hotspot-dial');
const hotspotBracelet = document.getElementById('hotspot-bracelet');
const hotspotMovement = document.getElementById('hotspot-movement');
const hotspotplay_video = document.getElementById('play-video');

const sizeConfig = {
    'hotspot-dial': {
        desktop: { scale: 0.855 },
        mobile: { scale: 0.7, offsetX: 20, offsetY: 170 }
    },
    'hotspot-design': {
        desktop: { scale: 0.85 },
        mobile: { scale: 0.5, offsetX: 0, offsetY: 190 }
    },
    'hotspot-bracelet': {
        desktop: { scale: 1.0 },
        mobile: { scale: 0.75, offsetX: 0, offsetY: 250 }
    },
    'hotspot-movement': {
        desktop: { scale: 1.2 },
        mobile: { scale: 0.55, offsetX: 45, offsetY: 130 }
    },
    'dial-right-to-left': {
        desktop: { scale: 0.855 },
        mobile: { scale: 1.0, offsetX: 0, offsetY: -15 }
    },
    'design-turn-to-center': {
        desktop: { scale: 0.77 },
        mobile: { scale: 0.9, offsetX: 0, offsetY: -15 }
    },
    'bracelet-micro-landscape': {
        desktop: { scale: 1.0 },
        mobile: { scale: 1.1, offsetX: 0, offsetY: 15 }
    },
    'movementopen': {
        desktop: { scale: 1.2 },
        mobile: { scale: 0.85, offsetX: 0, offsetY: 0 }
    },
    'default': {
        desktop: { scale: 0.6 },
        mobile: { scale: 0.9, offsetX: 0, offsetY: 0 }
    }
};

function isMobileView() {
    return window.innerWidth <= 768;
}

window.setAnimationSpeed = function (speed) {
    if (speed > 0) {
        animationSpeedFactor = speed;
    } else {
        console.log('Speed must be greater than 0');
    }
};

window.setViewer360Speed = function (speed) {
    if (speed > 0) {
        viewer360SpeedFactor = speed;
    } else {
        console.log('Speed must be greater than 0');
    }
};


window.initializeViewers = function(viewerData, viewerKey = 'viewer-one') {
    viewers[viewerKey] = {
        basePath: viewerData.basePath || '',
        folders: [
            {
                path: viewerData.folder_1_path,
                totalImages: viewerData.folder_1_total_images,
                images: []
            },
            {
                path: viewerData.folder_2_path,
                totalImages: viewerData.folder_2_total_images,
                images: []
            },
            {
                path: viewerData.folder_3_path,
                totalImages: viewerData.folder_3_total_images,
                images: []
            },
            {
                path: viewerData.folder_4_path,
                totalImages: viewerData.folder_4_total_images,
                images: []
            },
            {
                path: viewerData.folder_5_path,
                totalImages: viewerData.folder_5_total_images,
                images: []
            }
        ],
        transitionSequences: {
            'hotspot-dial': {
                path: viewerData.hotspot_dial_path,
                totalImages: viewerData.hotspot_dial_total_images,
                images: [],
                nextSequence: 'dial-right-to-left'
            },
            'hotspot-design': {
                path: viewerData.hotspot_design_path,
                totalImages: viewerData.hotspot_design_total_images,
                images: [],
                nextSequence: 'design-turn-to-center'
            },
            'hotspot-bracelet': {
                path: viewerData.hotspot_bracelet_path,
                totalImages: viewerData.hotspot_bracelet_total_images,
                images: [],
                nextSequence: 'bracelet-micro-landscape'
            },
            'hotspot-movement': {
                path: viewerData.hotspot_movement_path,
                totalImages: viewerData.hotspot_movement_total_images,
                images: [],
                nextSequence: 'movementopen'
            },
            'dial-right-to-left': {
                path: viewerData.dial_right_to_left_path,
                totalImages: viewerData.dial_right_to_left_total_images,
                images: []
            },
            'design-turn-to-center': {
                path: viewerData.design_turn_to_center_path,
                totalImages: viewerData.design_turn_to_center_total_images,
                images: []
            },
            'bracelet-micro-landscape': {
                path: viewerData.bracelet_micro_landscape_path,
                totalImages: viewerData.bracelet_micro_landscape_total_images,
                images: []
            },
            'movementopen': {
                path: viewerData.movement_open_path,
                totalImages: viewerData.movement_open_total_images,
                images: []
            }
        }
    };
    console.log(`Viewer ${viewerKey} initialized with schema data:`, viewers[viewerKey]);

    preloadImages(viewerKey).then(() => {
        console.log(`Images preloaded for ${viewerKey}`);
        if (viewerKey === activeViewer) {
            drawImage(currentIndex_canvas);
            updateHotspots();
        }
    }).catch(err => {
        console.error(`Error preloading images for ${viewerKey}:`, err);
    });
};

window.initializeDynamicViewers = function() {
    const viewerButtons = document.querySelectorAll('.three-viewer-main button');
    viewers = {};
    preloadStatus = {};

    viewerButtons.forEach((button, index) => {
        const viewerKey = `viewer-${index + 1}`;
        const viewerData = {
            basePath: button.dataset.basePath || '',
            folder_1_path: button.dataset.folder1Path,
            folder_1_total_images: parseInt(button.dataset.folder1TotalImages) || 12,
            folder_2_path: button.dataset.folder2Path,
            folder_2_total_images: parseInt(button.dataset.folder2TotalImages) || 12,
            folder_3_path: button.dataset.folder3Path,
            folder_3_total_images: parseInt(button.dataset.folder3TotalImages) || 42,
            folder_4_path: button.dataset.folder4Path,
            folder_4_total_images: parseInt(button.dataset.folder4TotalImages) || 13,
            folder_5_path: button.dataset.folder5Path,
            folder_5_total_images: parseInt(button.dataset.folder5TotalImages) || 24,
            hotspot_dial_path: button.dataset.hotspotDialPath,
            hotspot_dial_total_images: parseInt(button.dataset.hotspotDialTotalImages) || 31,
            hotspot_design_path: button.dataset.hotspotDesignPath,
            hotspot_design_total_images: parseInt(button.dataset.hotspotDesignTotalImages) || 29,
            hotspot_bracelet_path: button.dataset.hotspotBraceletPath,
            hotspot_bracelet_total_images: parseInt(button.dataset.hotspotBraceletTotalImages) || 29,
            hotspot_movement_path: button.dataset.hotspotMovementPath,
            hotspot_movement_total_images: parseInt(button.dataset.hotspotMovementTotalImages) || 74,
            dial_right_to_left_path: button.dataset.dialRightToLeftPath,
            dial_right_to_left_total_images: parseInt(button.dataset.dialRightToLeftTotalImages) || 25,
            design_turn_to_center_path: button.dataset.designTurnToCenterPath,
            design_turn_to_center_total_images: parseInt(button.dataset.designTurnToCenterTotalImages) || 25,
            bracelet_micro_landscape_path: button.dataset.braceletMicroLandscapePath,
            bracelet_micro_landscape_total_images: parseInt(button.dataset.braceletMicroLandscapeTotalImages) || 14,
            movement_open_path: button.dataset.movementOpenPath,
            movement_open_total_images: parseInt(button.dataset.movementOpenTotalImages) || 60
        };

        window.initializeViewers(viewerData, viewerKey);
        preloadStatus[viewerKey] = false;

        button.classList.add(viewerKey);
        if (index === 0) {
            button.classList.add('active');
            activeViewer = viewerKey;
            preloadImages(activeViewer).then(() => {
                drawImage(currentIndex_canvas);
                updateHotspots();
            });
        }

        button.addEventListener('click', () => {
            if (!button.classList.contains('active')) {
                window.switchViewer(viewerKey);
            }
        });
    });
};


const transitionFrameDurations = {
    'hotspot-bracelet': 40,
    'hotspot-design': 40,
    'hotspot-dial': 40,
    'hotspot-movement': 25,
    'movementopen': 40,
    'default': 40
};


function showOverlayText() {
    const headingElement = document.getElementById('overlay-heading');
    const textElement = document.getElementById('overlay-text');

    if (headingElement && textElement) {
        headingElement.style.display = 'block';
        textElement.style.display = 'block';

        headingElement.style.left = isMobileView() ? '50%' : '60%';
        headingElement.style.top = isMobileView() ? '35%' : '40%';
        headingElement.style.transform = 'translateY(-50%)';
        headingElement.style.zIndex = '10';

        textElement.style.left = isMobileView() ? '50%' : '60%';
        textElement.style.top = isMobileView() ? '45%' : '50%';
        textElement.style.width = isMobileView() ? '45%' : '35%';
        textElement.style.zIndex = '10';
    }
}

function hideOverlayText() {
    const headingElement = document.getElementById('overlay-heading');
    const textElement = document.getElementById('overlay-text');

    if (headingElement && textElement) {
        headingElement.style.display = 'none';
        textElement.style.display = 'none';
    }
}

let isPreloadingComplete = false;

let preloadStatus = {
    'viewer-one': false,
    'viewer-two': false,
    'viewer-three': false,
    'viewer-four': false
};

function preloadImages(viewerKey) {
    const preloadPromises = [];
    const viewer = viewers[viewerKey];

    if (!viewer) {
        console.error(`Viewer ${viewerKey} not found`);
        return Promise.reject(`Viewer ${viewerKey} not found`);
    }

    viewer.folders.forEach(folder => {
        for (let i = 0; i < folder.totalImages; i++) {
            const img = new Image();
            const paddedIndex = i.toString().padStart(4, '0');
            img.src = `${folder.path}${paddedIndex}.png`;
            const promise = new Promise((resolve) => {
                img.onload = () => {
                    folder.images[i] = img;
                    resolve();
                };
                img.onerror = () => {
                    console.error(`Failed to preload 360 image: ${img.src}`);
                    resolve();
                };
            });
            preloadPromises.push(promise);
        }
    });

    Object.keys(viewer.transitionSequences).forEach(key => {
        const sequence = viewer.transitionSequences[key];
        for (let i = 0; i < sequence.totalImages; i++) {
            const img = new Image();
            const paddedIndex = i.toString().padStart(4, '0');
            img.src = `${sequence.path}${paddedIndex}.png`;
            const promise = new Promise((resolve) => {
                img.onload = () => {
                    sequence.images[i] = img;
                    resolve();
                };
                img.onerror = () => {
                    console.error(`Failed to preload transition image: ${img.src}`);
                    resolve();
                };
            });
            preloadPromises.push(promise);
        }
    });

    return Promise.all(preloadPromises).then(() => {
        preloadStatus[viewerKey] = true;
        if (viewerKey === activeViewer) {
            isPreloadingComplete = true;
            drawImage(currentIndex_canvas); 
        }
    }).catch(err => {
        console.error(`Error during preloading for viewer ${viewerKey}:`, err);
        preloadStatus[viewerKey] = true; 
        if (viewerKey === activeViewer) {
            isPreloadingComplete = true;
        }
    });
}

preloadImages(activeViewer).then(() => {
    console.log(`All images preloaded for ${activeViewer}`);
}).catch(err => {
    console.error(`Error during preloading for ${activeViewer}:`, err);
});

function updateHotspots() {
    const hotspots = document.querySelectorAll('.hotspot');
    hotspots.forEach(hotspot => {
        let wasActive = hotspot.classList.contains('active');
        hotspot.classList.remove('active');

        if (isInitialLoad && activeFolderIndex === 0 && hotspot.id === 'hotspot-design') {
            hotspot.classList.add('active');
        } else if (isMobileView() && activeFolderIndex === 0 && !activeMicroSequence && !isTransitionPlaying && hotspot.id === 'hotspot-design') {
            hotspot.classList.add('active');
        } else if (activeMicroSequence === 'design-turn-to-center') {
            if (hotspot.id === 'hotspot-design') hotspot.classList.add('active');
        } else if (activeMicroSequence === 'dial-right-to-left') {
            if (hotspot.id === 'hotspot-dial') hotspot.classList.add('active');
        } else if (activeMicroSequence === 'bracelet-micro-landscape') {
            if (hotspot.id === 'hotspot-bracelet') hotspot.classList.add('active');
        } else if (activeMicroSequence === 'movementopen') {
            if (hotspot.id === 'hotspot-movement') hotspot.classList.add('active');
        } else {
            if (autoPlayDirection < 0) {
                if (activeFolderIndex === 1 && hotspot.id === 'hotspot-dial') {
                    hotspot.classList.add('active');
                    if (isMobileView()) {
                        setTimeout(() => {
                            $('#hotspot-design').removeClass('active');
                        }, 500);
                    }
                }
               
                else if (activeFolderIndex === 2 && hotspot.id === 'hotspot-movement') {
                    hotspot.classList.add('active');
                    if (isMobileView()) {
                        setTimeout(() => {
                            $('#hotspot-design').removeClass('active');
                        }, 500);
                    }
                }
                else if (activeFolderIndex === 3 && hotspot.id === 'hotspot-bracelet') hotspot.classList.add('active');
                else if (activeFolderIndex === 4 && hotspot.id === 'hotspot-design') hotspot.classList.add('active');
                else if (activeFolderIndex === 0 && hotspot.id === 'play-video') hotspot.classList.add('active');
            } else if (autoPlayDirection > 0) {
                if (activeFolderIndex === 0 && hotspot.id === 'hotspot-design') hotspot.classList.add('active');
                else if (activeFolderIndex === 1 && hotspot.id === 'play-video') hotspot.classList.add('active');
                else if (activeFolderIndex === 2 && hotspot.id === 'hotspot-dial') hotspot.classList.add('active');
                else if (activeFolderIndex === 3 && hotspot.id === 'hotspot-movement') hotspot.classList.add('active');
                else if (activeFolderIndex === 4 && hotspot.id === 'hotspot-bracelet') hotspot.classList.add('active');
            }
        }

        if (isMobileView()) {
            if (hotspot.classList.contains('active') && !wasActive) {
                hotspot.style.display = 'block';
                hotspot.style.opacity = '0';
                hotspot.style.transition = 'opacity 0.5s ease-in';
                setTimeout(() => {
                    hotspot.style.opacity = '1';
                }, 10);
            } else if (!hotspot.classList.contains('active') && wasActive) {
                hotspot.style.transition = 'opacity 0.5s ease-out';
                hotspot.style.opacity = '0';
                setTimeout(() => {
                    hotspot.style.display = 'none';
                }, 500);
            }
             if (hotspot.id === 'hotspot-design' || hotspot.id === 'hotspot-dial' || hotspot.id === 'play-video') {
                hotspot.style.left = '50%';
                hotspot.style.transform = 'translateX(-50%)';
                hotspot.style.bottom = '24%';
            }
        }
    });

    if (isInitialLoad) {
        isInitialLoad = false;
    }
    if (autoPlayDirection < 0 && !activeMicroSequence) {
        const lastFrame = viewers[activeViewer].folders[activeFolderIndex].images.length - 1;
        if (microSequenceIndex !== lastFrame) {
            microSequenceIndex = lastFrame;
            drawImage(microSequenceIndex);
        }
    }
}

function positionHotspots(drawWidth, drawHeight, offsetX, offsetY) {
    const imageWidth = drawWidth;
    const imageHeight = drawHeight;

    if (isMobileView()) {
        hotspotDesign.style.left = '50%';
        hotspotDesign.style.transform = 'translateX(-50%)';
        hotspotDesign.style.bottom = '24%';

        hotspotDial.style.left = '50%';
        hotspotDial.style.transform = 'translateX(-50%)';
        hotspotDial.style.bottom = '24%';

        hotspotBracelet.style.left = '50%';
        hotspotBracelet.style.transform = 'translateX(-50%)';
        hotspotBracelet.style.bottom = '24%';

        hotspotMovement.style.left = '50%';
        hotspotMovement.style.transform = 'translateX(-50%)';
        hotspotMovement.style.bottom = '24%';

        hotspotplay_video.style.left = '50%';
        hotspotplay_video.style.transform = 'translateX(-50%)';
        hotspotplay_video.style.bottom = '24%';
    } else {
        hotspotDesign.style.left = `${offsetX + imageWidth * 1.0}px`;
        hotspotDesign.style.top = `${offsetY + imageHeight * 0.15}px`;
        hotspotDial.style.left = `${offsetX + imageWidth * -0.2}px`;
        hotspotDial.style.top = `${offsetY + imageHeight * 0.15}px`;
        hotspotBracelet.style.left = `${offsetX + imageWidth * 1.0}px`;
        hotspotBracelet.style.top = `${offsetY + imageHeight *  0.85}px`;
        hotspotMovement.style.left = `${offsetX + imageWidth * -0.2}px`;
        hotspotMovement.style.top = `${offsetY + imageHeight * 0.85}px`;
        hotspotplay_video.style.left = `${offsetX + imageWidth * 0.48}px`;
        hotspotplay_video.style.top = `${offsetY + imageHeight * -0.1}px`;
    }
}



function showVideoPopup() {
  const videoPopup = document.querySelector('.video-popup');
  const video = document.querySelector('.popup-video');
  if (videoPopup && video) {
    videoPopup.classList.add('active');
    video.play();
    updateHotspots();
  }
}




function hideVideoPopup() {
  const popup = document.querySelector('.video-popup');
  if (popup) {
    popup.classList.remove('active');
    const video = popup.querySelector('.popup-video');
    if (popup && video) {
      video.pause(); 
      video.currentTime = 0; 
      popup.classList.remove('active');
      updateHotspots();
    }
    const hotspotsContainer = document.querySelector('.hotspots');
    if (hotspotsContainer) {
      hotspotsContainer.style.display = 'block';
      const hotspots = hotspotsContainer.querySelectorAll('.hotspot');
      hotspots.forEach(hotspot => {
        hotspot.style.opacity = '0';
        hotspot.style.transition = 'opacity 0.5s ease-in';
        setTimeout(() => {
          hotspot.style.opacity = '1';
        }, 10);
      });
      const lastActiveElement = document.getElementById(lastActiveHotspot);
      if (lastActiveElement) {
        lastActiveElement.classList.add('active');
      }
    }
  }
}
let startY_canvas = 0;
let startTouchY_canvas = 0;
let dragDistanceY = 0;
let lastTouchTime = 0;

function getPointAlongPath(pathId, progress) {
    const path = document.getElementById(pathId);
    if (!path) return { x: 0, y: 0 };
    const totalLength = path.getTotalLength();
    const point = path.getPointAtLength(progress * totalLength);
    return { x: point.x, y: point.y };
}

function updateDesignSliderThumb(progress) {
    const thumb = document.getElementById('design-thumb');
    if (!thumb) return;
    const point = getPointAlongPath('design-curve', progress);
    thumb.style.left = `${point.x}px`;
    thumb.style.top = `${point.y}px`;
}

function updateDialSliderThumb(progress) {
    const thumb = document.getElementById('dial-thumb');
    if (!thumb) return;
    const point = getPointAlongPath('dial-curve', progress);
    thumb.style.left = `${point.x}px`;
    thumb.style.top = `${point.y}px`;
}

function updateBraceletSliderThumb(progress) {
    const thumb = document.getElementById('bracelet-thumb');
    if (!thumb) return;
    const point = getPointAlongPath('bracelet-curve', progress);
    thumb.style.left = `${point.x}px`;
    thumb.style.top = `${point.y}px`;

    if (progress > 0 && progress < 1) {
    } else {
    }
}

canvas_pro.addEventListener('mousedown', (e) => {
    if (isTransitionPlaying) return;
    isDragging_canvas = true;
    startX_canvas = e.clientX;
    startY_canvas = e.clientY;
    accumulatedDrag = 0;
    dragDistanceY = 0;
    if (['design-turn-to-center', 'dial-right-to-left', 'bracelet-micro-landscape', 'movementopen'].includes(activeMicroSequence)) {
        e.preventDefault();
    } else {
        window.onDragStart();
    }
    if (activeMicroSequence === 'bracelet-micro-landscape') {
    }
});

const bgPositionConfig = {
    'design-turn-to-center': 16,
    'dial-right-to-left': 20,
    'bracelet-micro-landscape': 10,
    'movementopen': 10
};


window.addEventListener('mousemove', (e) => {
    if (isDragging_canvas && !isSliderAutoPlaying) {
        if (activeMicroSequence === 'design-turn-to-center') {
            const diffY = e.clientY - startY_canvas;
            const totalFrames = viewers[activeViewer].transitionSequences[activeMicroSequence].images.length;
            const frameChange = Math.round(diffY / 10);
            microSequenceIndex = microSequenceIndex - frameChange;
            microSequenceIndex = Math.max(0, Math.min(totalFrames - 1, microSequenceIndex));
            drawImage(microSequenceIndex);
            startY_canvas = e.clientY;

            const progress = microSequenceIndex / (totalFrames - 1);
            updateDesignSliderThumb(progress);

            const slideBg = document.querySelector('.slide-bg');
            if (slideBg && microSequenceIndex > 0 && microSequenceIndex < totalFrames - 1) {
                const maxBgPosition = bgPositionConfig[activeMicroSequence];
                const bgPosition = (microSequenceIndex / (totalFrames - 1)) * maxBgPosition;
                slideBg.style.backgroundPosition = `center -${bgPosition}px`;
            }

            if (Math.abs(diffY) >= 10) {
                const direction = diffY > 0 ? -1 : 1;
                window.startSliderAutoPlay(activeMicroSequence, direction);
            }
        } else if (activeMicroSequence === 'bracelet-micro-landscape') {
            const diffY = e.clientY - startY_canvas;
            const totalFrames = viewers[activeViewer].transitionSequences[activeMicroSequence].images.length;
            const frameChange = Math.round(diffY / 10);
            microSequenceIndex = microSequenceIndex + frameChange;
            microSequenceIndex = Math.max(0, Math.min(totalFrames - 1, microSequenceIndex));
            drawImage(microSequenceIndex);
            startY_canvas = e.clientY;

            const progress = microSequenceIndex / (totalFrames - 1);
            updateBraceletSliderThumb(progress);

            const slideBg = document.querySelector('.slide-bg');
            if (slideBg && microSequenceIndex > 0 && microSequenceIndex < totalFrames - 1) {
                const maxBgPosition = bgPositionConfig[activeMicroSequence];
                const bgPosition = (microSequenceIndex / (totalFrames - 1)) * maxBgPosition;
                slideBg.style.backgroundPosition = `center -${bgPosition}px`;
            }

            if (Math.abs(diffY) >= 10) {
                const direction = diffY > 0 ? 1 : -1;
                window.startSliderAutoPlay(activeMicroSequence, direction);
            }
        } else if (activeMicroSequence === 'dial-right-to-left') {
            const diffX = e.clientX - startX_canvas;
            const totalFrames = viewers[activeViewer].transitionSequences[activeMicroSequence].images.length;
            const frameChange = Math.round(diffX / 10);
            microSequenceIndex = microSequenceIndex - frameChange;
            microSequenceIndex = Math.max(0, Math.min(totalFrames - 1, microSequenceIndex));
            drawImage(microSequenceIndex);
            startX_canvas = e.clientX;

            const progress = (totalFrames - 1 - microSequenceIndex) / (totalFrames - 1);
            updateDialSliderThumb(progress);

            const slideBg = document.querySelector('.slide-bg');
            if (slideBg && microSequenceIndex > 0 && microSequenceIndex < totalFrames - 1) {
                const maxBgPosition = bgPositionConfig[activeMicroSequence];
                const bgPosition = ((totalFrames - 1 - microSequenceIndex) / (totalFrames - 1)) * maxBgPosition;
                slideBg.style.backgroundPosition = `-${bgPosition}px center`;
            }

            if (Math.abs(diffX) >= 10) {
                const direction = diffX > 0 ? 1 : -1;
                window.startSliderAutoPlay(activeMicroSequence, direction);
            }
        } else if (activeMicroSequence === 'movementopen') {
            const diffY = e.clientY - startY_canvas;
            const totalFrames = viewers[activeViewer].transitionSequences[activeMicroSequence].images.length;
            const frameChange = Math.round(diffY / 10);
            microSequenceIndex = microSequenceIndex + frameChange;
            microSequenceIndex = Math.max(0, Math.min(totalFrames - 1, microSequenceIndex));
            drawImage(microSequenceIndex);
            startY_canvas = e.clientY;

            const slideBg = document.querySelector('.slide-bg');
            if (slideBg && microSequenceIndex > 0 && microSequenceIndex < totalFrames - 1) {
                const maxBgPosition = bgPositionConfig[activeMicroSequence];
                const bgPosition = (microSequenceIndex / (totalFrames - 1)) * maxBgPosition;
                slideBg.style.backgroundPosition = `center -${bgPosition}px`;
            }

            if (Math.abs(diffY) >= 10) {
                const direction = diffY > 0 ? 1 : -1;
                window.startSliderAutoPlay(activeMicroSequence, direction);
            }
        } else {
            const diff = startX_canvas - e.clientX;
            accumulatedDrag += diff * 0.3;
            if (Math.abs(accumulatedDrag) > 4) {
                autoPlayDirection = accumulatedDrag > 0 ? -1 : 1;
                if (!isAutoPlaying) {
                    isAutoPlaying = true;
                    lastFrameTime = performance.now();
                    requestAnimationFrame(autoPlay);
                }
                accumulatedDrag = Math.min(Math.max(accumulatedDrag, -50), 50);
            }
            startX_canvas = e.clientX;
        }
    }
});

window.addEventListener('mouseup', () => {
    isDragging_canvas = false;
    if (['design-turn-to-center', 'dial-right-to-left', 'bracelet-micro-landscape', 'movementopen'].includes(activeMicroSequence)) {
        drawImage(microSequenceIndex);
    } else {
        drawImage(currentIndex_canvas); 
    }
    if (activeMicroSequence === 'bracelet-micro-landscape') {
    }
});

canvas_pro.addEventListener('touchstart', (e) => {
    if (isTransitionPlaying || isLoopingAnimationPlaying) return;
    isDragging_canvas = true;
    startTouchX_canvas = e.touches[0].clientX;
    startTouchY_canvas = e.touches[0].clientY;
    accumulatedDrag = 0;
    dragDistanceY = 0;
    lastTouchTime = performance.now();
    isSliderAutoPlaying = false;
    if (['design-turn-to-center', 'dial-right-to-left', 'bracelet-micro-landscape', 'movementopen'].includes(activeMicroSequence)) {
        e.preventDefault();
    } else {
        window.onDragStart();
    }
    if (activeMicroSequence === 'bracelet-micro-landscape') {
    }
});

window.addEventListener('touchmove', (e) => {
    if (!isDragging_canvas || isSliderAutoPlaying) return;
    e.preventDefault();
    const currentTime = performance.now();
    if (currentTime - lastTouchTime < 10) return;
    lastTouchTime = currentTime;

    if (activeMicroSequence === 'design-turn-to-center') {
        const diffY = e.touches[0].clientY - startTouchY_canvas;
        const totalFrames = viewers[activeViewer].transitionSequences[activeMicroSequence].images.length;
        const frameChange = Math.round(diffY / 10);
        microSequenceIndex = microSequenceIndex - frameChange;
        microSequenceIndex = Math.max(0, Math.min(totalFrames - 1, microSequenceIndex));
        drawImage(microSequenceIndex);
        startTouchY_canvas = e.touches[0].clientY;

        const progress = microSequenceIndex / (totalFrames - 1);
        updateDesignSliderThumb(progress);

        const slideBg = document.querySelector('.slide-bg');
        if (slideBg && microSequenceIndex > 0 && microSequenceIndex < totalFrames - 1) {
            const maxBgPosition = bgPositionConfig[activeMicroSequence];
            const bgPosition = (microSequenceIndex / (totalFrames - 1)) * maxBgPosition;
            slideBg.style.backgroundPosition = `center -${bgPosition}px`;
        }

        if (Math.abs(diffY) >= 10) {
            const direction = diffY > 0 ? -1 : 1;
            window.startSliderAutoPlay(activeMicroSequence, direction);
        }
    } else if (activeMicroSequence === 'bracelet-micro-landscape') {
        const diffY = e.touches[0].clientY - startTouchY_canvas;
        const totalFrames = viewers[activeViewer].transitionSequences[activeMicroSequence].images.length;
        const frameChange = Math.round(diffY / 10);
        microSequenceIndex = microSequenceIndex + frameChange;
        microSequenceIndex = Math.max(0, Math.min(totalFrames - 1, microSequenceIndex));
        drawImage(microSequenceIndex);
        startTouchY_canvas = e.touches[0].clientY;

        const progress = microSequenceIndex / (totalFrames - 1);
        updateBraceletSliderThumb(progress);

        const slideBg = document.querySelector('.slide-bg');
        if (slideBg && microSequenceIndex > 0 && microSequenceIndex < totalFrames - 1) {
            const maxBgPosition = bgPositionConfig[activeMicroSequence];
            const bgPosition = (microSequenceIndex / (totalFrames - 1)) * maxBgPosition;
            slideBg.style.backgroundPosition = `center -${bgPosition}px`;
        }

        if (Math.abs(diffY) >= 10) {
            const direction = diffY > 0 ? 1 : -1;
            window.startSliderAutoPlay(activeMicroSequence, direction);
        }
    } else if (activeMicroSequence === 'dial-right-to-left') {
        const diffX = e.touches[0].clientX - startTouchX_canvas;
        const totalFrames = viewers[activeViewer].transitionSequences[activeMicroSequence].images.length;
        const frameChange = Math.round(diffX / 10);
        microSequenceIndex = microSequenceIndex - frameChange;
        microSequenceIndex = Math.max(0, Math.min(totalFrames - 1, microSequenceIndex));
        drawImage(microSequenceIndex);
        startTouchX_canvas = e.touches[0].clientX;

        const progress = (totalFrames - 1 - microSequenceIndex) / (totalFrames - 1);
        updateDialSliderThumb(progress);

        const slideBg = document.querySelector('.slide-bg');
        if (slideBg && microSequenceIndex > 0 && microSequenceIndex < totalFrames - 1) {
            const maxBgPosition = bgPositionConfig[activeMicroSequence];
            const bgPosition = ((totalFrames - 1 - microSequenceIndex) / (totalFrames - 1)) * maxBgPosition;
            slideBg.style.backgroundPosition = `-${bgPosition}px center`;
        }

        if (Math.abs(diffX) >= 10) {
            const direction = diffX > 0 ? 1 : -1;
            window.startSliderAutoPlay(activeMicroSequence, direction);
        }
    } else if (activeMicroSequence === 'movementopen') {
        const diffY = e.touches[0].clientY - startTouchY_canvas;
        const totalFrames = viewers[activeViewer].transitionSequences[activeMicroSequence].images.length;
        const frameChange = Math.round(diffY / 10);
        microSequenceIndex = microSequenceIndex + frameChange;
        microSequenceIndex = Math.max(0, Math.min(totalFrames - 1, microSequenceIndex));
        drawImage(microSequenceIndex);
        startTouchY_canvas = e.touches[0].clientY;

        const slideBg = document.querySelector('.slide-bg');
        if (slideBg && microSequenceIndex > 0 && microSequenceIndex < totalFrames - 1) {
            const maxBgPosition = bgPositionConfig[activeMicroSequence];
            const bgPosition = (microSequenceIndex / (totalFrames - 1)) * maxBgPosition;
            slideBg.style.backgroundPosition = `center -${bgPosition}px`;
        }

        if (Math.abs(diffY) >= 10) {
            const direction = diffY > 0 ? 1 : -1;
            window.startSliderAutoPlay(activeMicroSequence, direction);
        }
    } else {
        const diff = startTouchX_canvas - e.touches[0].clientX;
        accumulatedDrag += diff * 0.3;
        if (Math.abs(accumulatedDrag) > 4) {
            autoPlayDirection = accumulatedDrag > 0 ? -1 : 1;
            if (!isAutoPlaying && !isTransitionPlaying) {
                isAutoPlaying = true;
                lastFrameTime = performance.now();
                requestAnimationFrame(autoPlay);
            }
            accumulatedDrag = Math.min(Math.max(accumulatedDrag, -50), 50);
        }
        startTouchX_canvas = e.touches[0].clientX;
    }
});

window.addEventListener('touchend', () => {
    isDragging_canvas = false;
    if (['design-turn-to-center', 'dial-right-to-left', 'bracelet-micro-landscape', 'movementopen'].includes(activeMicroSequence)) {
        drawImage(microSequenceIndex);
    } else {
        drawImage(currentIndex_canvas);
    }
    if (isAutoPlaying && Math.abs(accumulatedDrag) < 0.1) {
        isAutoPlaying = false;
    }

    if (activeMicroSequence === 'bracelet-micro-landscape') {
        // stopBraceletSound();
    }
});

let hotspotPositions = {
    'hotspot-design': { offsetX: 0, offsetY: 26, drawWidth: 0, drawHeight: 0, left: 50 },
    'hotspot-dial': { offsetX: 0, offsetY: 0, drawWidth: 0, drawHeight: 0 },
    'hotspot-bracelet': { offsetX: 0, offsetY: 0, drawWidth: 0, drawHeight: 0 },
    'hotspot-movement': { offsetX: 0, offsetY: 0, drawWidth: 0, drawHeight: 0 }
};

let isInitialLoad = true;

const mobileTransitionConfig = {
    'hotspot-design': {
        forward: {
            startOffsetX: -0.5, 
            startOffsetY: 0.65, 
            endOffsetX: 0.5,   
            endOffsetY: 0.85   
        },
        reverse: {
            startOffsetX: -0.5,
            startOffsetY: 0.65, 
            endOffsetX: 0.5,  
            endOffsetY: 0.85    
        }
    },
    'hotspot-dial': {
        forward: {
            startOffsetX: 1.1,
            startOffsetY: 1.1, 
            endOffsetX: 0.2,  
            endOffsetY: 1.1  
        },
        reverse: {
            startOffsetX: 1.1,
            startOffsetY: 1.1, 
            endOffsetX: 0.2,   
            endOffsetY: 1.1    
        }
    },
    'hotspot-bracelet': {
        forward: {
            startOffsetX: -0.45, 
            startOffsetY: 0.50,
            endOffsetX: 0.10,  
            endOffsetY: 1.5  
        },
        reverse: {
            startOffsetX: -0.35, 
            startOffsetY: 0.70, 
            endOffsetX: 0.10, 
            endOffsetY: 1.5   
        }
    }
};


function drawImage(index, isTransition = false, sequence = null, useFullscreenCanvas = false, skipClear = false, folderIndex = null) {
    let img, ctx, canvas;

    canvas = canvas_pro;
    ctx = ctx_pro;

    if (!preloadStatus[activeViewer]) {
        console.log(`Preloading not complete for ${activeViewer}, delaying drawImage`);
        setTimeout(() => drawImage(index, isTransition, sequence, useFullscreenCanvas, skipClear, folderIndex), 100);
        return;
    }

    const effectiveFolderIndex = folderIndex !== null ? folderIndex : activeFolderIndex;

    if (isTransition && sequence) {
        img = sequence.images[index];
    } else if (activeMicroSequence) {
        if (!viewers[activeViewer].transitionSequences || !viewers[activeViewer].transitionSequences[activeMicroSequence]) {
            console.error(`Sequence ${activeMicroSequence} is not defined for viewer ${activeViewer}`);
            activeMicroSequence = null;
            const activeFolder = viewers[activeViewer].folders[effectiveFolderIndex];
            img = activeFolder.images[index];
        } else {
            img = viewers[activeViewer].transitionSequences[activeMicroSequence].images[index];
        }
    } else {
        const activeFolder = viewers[activeViewer].folders[effectiveFolderIndex];
        img = activeFolder.images[index];
    }

    if (!img) {
        console.warn(`Image not available at index ${index} for sequence ${currentSequenceKey || activeMicroSequence || 'main'} in viewer ${activeViewer}`);
        return;
    }

    offscreenCanvas.width = canvas.width;
    offscreenCanvas.height = canvas.height;
    if (!skipClear) {
        offscreenCtx.clearRect(0, 0, offscreenCanvas.width, offscreenCanvas.height);
    }

    let drawWidth, drawHeight, offsetX, offsetY;
    const sequenceKey = currentSequenceKey || activeMicroSequence || 'default';
    const config = sizeConfig[sequenceKey] || sizeConfig['default'];
    const scale = isMobileView() ? config.mobile.scale : config.desktop.scale;
    const mobileOffsetX = isMobileView() && config.mobile.offsetX ? config.mobile.offsetX : 0;
    const mobileOffsetY = isMobileView() && config.mobile.offsetY ? config.mobile.offsetY : 0;

    if (activeMicroSequence === 'design-turn-to-center') {
        drawHeight = canvas.height * scale;
        drawWidth = drawHeight * (img.width / img.height);
        offsetX = isMobileView() ? (canvas.width * 0.5 - drawWidth / 2 + mobileOffsetX) : (canvas.width * 0.67 - drawWidth / 2);
        offsetY = isMobileView() ? (canvas.height * 0.5 - drawHeight / 1.75 + mobileOffsetY) : (canvas.height * 0.64 - drawHeight / 1.7);
    } else if (isTransition && currentSequenceKey === 'hotspot-design') {
        drawHeight = canvas.height * scale;
        drawWidth = drawHeight * (img.width / img.height);
        const progress = index / (sequence.totalImages - 1);
        if (isMobileView()) {
            const transConfig = isReverseTransition ? mobileTransitionConfig['hotspot-design'].reverse : mobileTransitionConfig['hotspot-design'].forward;
            offsetX = (canvas.width - drawWidth) * transConfig.startOffsetX + ((canvas.width - drawWidth) * transConfig.endOffsetX - (canvas.width - drawWidth) * transConfig.startOffsetX) * progress;
            offsetY = (canvas.height - drawHeight) * transConfig.startOffsetY + ((canvas.height - drawHeight) * transConfig.endOffsetY - (canvas.height - drawHeight) * transConfig.startOffsetY) * progress;
        } else {
            const startOffsetX = (canvas.width - drawWidth) / 2 + 100;
            const startOffsetY = (canvas.height - drawHeight) / 2 + 50;
            const endOffsetX = (canvas.width * 0.65 - drawWidth / 2);
            const endOffsetY = (canvas.height * 0.60 - drawHeight / 2);
            if (isReverseTransition) {
                offsetX = (endOffsetX + (startOffsetX - endOffsetX) * progress) - 10;
                offsetY = (endOffsetY + (startOffsetY - endOffsetY) * progress) + 20;
            } else {
                offsetX = startOffsetX + (endOffsetX - startOffsetX) * progress;
                offsetY = startOffsetY + (endOffsetY - startOffsetY) * progress;
            }
        }
    } else if (isTransition && currentSequenceKey === 'hotspot-bracelet') {
        drawHeight = canvas.height * scale;
        drawWidth = drawHeight * (img.width / img.height);
        const progress = index / (sequence.totalImages - 1);
        if (isMobileView()) {
            const transConfig = isReverseTransition ? mobileTransitionConfig['hotspot-bracelet'].reverse : mobileTransitionConfig['hotspot-bracelet'].forward;
            offsetX = (canvas.width - drawWidth) * transConfig.startOffsetX + ((canvas.width - drawWidth) * transConfig.endOffsetX - (canvas.width - drawWidth) * transConfig.startOffsetX) * progress;
            offsetY = (canvas.height - drawHeight) * transConfig.startOffsetY + ((canvas.height - drawHeight) * transConfig.endOffsetY - (canvas.height - drawHeight) * transConfig.startOffsetY) * progress;
        } else {
            const startOffsetX = (canvas.width - drawWidth) / 2 + 190;
            const startOffsetY = (canvas.height - drawHeight) / 2;
            const endOffsetX = (canvas.width * 0.65 - drawWidth / 2);
            const endOffsetY = (canvas.height * 0.50 - drawHeight / 2);
            if (isReverseTransition) {
                offsetX = (endOffsetX + (startOffsetX - endOffsetX) * progress) - 10;
                offsetY = (endOffsetY + (startOffsetY - endOffsetY) * progress) + 20;
            } else {
                offsetX = startOffsetX + (endOffsetX - startOffsetX) * progress;
                offsetY = startOffsetY + (endOffsetY - startOffsetY) * progress;
            }
        }
    } else if (isTransition && currentSequenceKey === 'hotspot-dial') {
        drawHeight = canvas.height * scale;
        drawWidth = drawHeight * (img.width / img.height);
        const progress = index / (sequence.totalImages - 1);
        if (isMobileView()) {
            const transConfig = isReverseTransition ? mobileTransitionConfig['hotspot-dial'].reverse : mobileTransitionConfig['hotspot-dial'].forward;
            offsetX = (canvas.width - drawWidth) * transConfig.startOffsetX + ((canvas.width - drawWidth) * transConfig.endOffsetX - (canvas.width - drawWidth) * transConfig.startOffsetX) * progress;
            offsetY = (canvas.height - drawHeight) * transConfig.startOffsetY + ((canvas.height - drawHeight) * transConfig.endOffsetY - (canvas.height - drawHeight) * transConfig.startOffsetY) * progress;
        } else {
            const startOffsetX = (canvas.width - drawWidth) * 0.205;
            const startOffsetY = (canvas.height - drawHeight) * 1.37;
            const endOffsetX = (canvas.width - drawWidth) * 0.345;
            const endOffsetY = (canvas.height - drawHeight) * 1.37;
            if (isReverseTransition) {
                offsetX = endOffsetX + (startOffsetX - endOffsetX) * progress - 0.205;
                offsetY = endOffsetY + (startOffsetY - endOffsetY) * progress;
            } else {
                offsetX = startOffsetX + (endOffsetX - startOffsetX) * progress;
                offsetY = startOffsetY + (endOffsetY - startOffsetY) * progress;
            }
        }
    } else if (isTransition && currentSequenceKey === 'hotspot-movement') {
        drawHeight = canvas.height * scale;
        drawWidth = drawHeight * (img.width / img.height);
        const progress = index / (sequence.totalImages - 1);
        const startOffsetX = (canvas.width - drawWidth) / 2;
        const startOffsetY = (canvas.height - drawHeight) / 2;
        const endOffsetX = isMobileView() ? ((canvas.width - drawWidth) / 2 + mobileOffsetX) : ((canvas.width - drawWidth) / 2 - 10);
        const endOffsetY = isMobileView() ? ((canvas.height - drawHeight) / 2 + mobileOffsetY) : ((canvas.height - drawHeight) / 2);
        offsetX = startOffsetX + (endOffsetX - startOffsetX) * progress;
        offsetY = startOffsetY + (endOffsetY - startOffsetY) * progress;
    } else if (activeMicroSequence === 'bracelet-micro-landscape') {
        const scale = isMobileView() ? 0.6 : 0.89;
        drawHeight = canvas.height * scale;
        drawWidth = drawHeight * (img.width / img.height);
        offsetX = isMobileView() ? (canvas.width * 0.52 - drawWidth / 2.1 + mobileOffsetX) : (canvas.width * 0.79 - drawWidth / 2.5);
        offsetY = isMobileView() ? (canvas.height * 0.45 - drawHeight / 1.4 + mobileOffsetY) : (canvas.height * 0.42 - drawHeight / 2.5);
    } else if (activeMicroSequence === 'dial-right-to-left') {
        const scale = isMobileView() ? 0.455 : 0.855;
        drawHeight = canvas.height * scale;
        drawWidth = drawHeight * (img.width / img.height);
        offsetX = isMobileView() ? ((canvas.width - drawWidth) * 0.48 + mobileOffsetX) : ((canvas.width - drawWidth) * 0.28);
        offsetY = isMobileView() ? ((canvas.height - drawHeight) * 0.52 + mobileOffsetY) : ((canvas.height - drawHeight) * 0.7);
    } else if (activeMicroSequence === 'movementopen') {
        drawHeight = canvas.height * scale;
        drawWidth = drawHeight * (img.width / img.height);
        offsetX = isMobileView() ? ((canvas.width - drawWidth) / 2 + mobileOffsetX) : ((canvas.width * 0.93 - drawWidth) / 2);
        offsetY = isMobileView() ? ((canvas.height - drawHeight) / 2 + mobileOffsetY) : ((canvas.height - drawHeight) / 2);
    } else if (activeMicroSequence) {
        drawHeight = canvas.height * scale;
        drawWidth = drawHeight * (img.width / img.height);
        offsetX = isMobileView() ? (canvas.width * 0.5 - drawWidth / 2 + mobileOffsetX) : (canvas.width * 0.67 - drawWidth / 2);
        offsetY = isMobileView() ? (canvas.height * 0.5 - drawHeight / 2 + mobileOffsetY) : (canvas.height * 0.64 - drawHeight / 2);
    } else {
        const imgAspectRatio = img.width / img.height;
        if (canvas.width / canvas.height > imgAspectRatio) {
            drawHeight = canvas.height * scale;
            drawWidth = drawHeight * imgAspectRatio;
        } else {
            drawWidth = canvas.width * scale;
            drawHeight = drawWidth / imgAspectRatio;
        }
        offsetX = isMobileView() ? ((canvas.width - drawWidth) / 2 + mobileOffsetX) : ((canvas.width - drawWidth) / 2);
        offsetY = isMobileView() ? ((canvas.height - drawHeight) / 2 + mobileOffsetY) : ((canvas.height - drawHeight) / 2);
    }

    offscreenCtx.imageSmoothingEnabled = true;
    offscreenCtx.imageSmoothingQuality = 'high';
    offscreenCtx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);

    if (!skipClear) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(offscreenCanvas, 0, 0, canvas.width, canvas.height);

    if (isMobileView()) {
        positionHotspots(drawWidth, drawHeight, offsetX, offsetY);
   
        hotspotDesign.style.left = '50%';
        hotspotDesign.style.transform = 'translateX(-50%)';
        hotspotDesign.style.bottom = '24%';
    } else {
        updateHotspots();
        positionHotspots(drawWidth, drawHeight, offsetX, offsetY);
    }
}

function changeImage(direction, steps = 1) {
    const activeFolder = viewers[activeViewer].folders[activeFolderIndex];
    currentIndex_canvas += direction * steps;

    let folderChanged = false;

    if (currentIndex_canvas < 0) {
        activeFolderIndex = (activeFolderIndex - 1 + viewers[activeViewer].folders.length) % viewers[activeViewer].folders.length;
        currentIndex_canvas = viewers[activeViewer].folders[activeFolderIndex].images.length - 1;
        isAutoPlaying = false;
        folderChanged = true;
    } else if (currentIndex_canvas >= activeFolder.images.length) {
        activeFolderIndex = (activeFolderIndex + 1) % viewers[activeViewer].folders.length;
        currentIndex_canvas = 0;
        isAutoPlaying = false;
        folderChanged = true;
    }

    if (folderChanged) {
        updateHotspots();
        const activeFolder = viewers[activeViewer].folders[activeFolderIndex];
        const img = activeFolder.images[currentIndex_canvas];
        if (img) {
            const imgAspectRatio = img.width / img.height;
            let drawWidth, drawHeight;
            const config = sizeConfig['default'];
            const scale = isMobileView() ? config.mobile.scale : config.desktop.scale;
            const mobileOffsetX = isMobileView() && config.mobile.offsetX ? config.mobile.offsetX : 0;
            const mobileOffsetY = isMobileView() && config.mobile.offsetY ? config.mobile.offsetY : 0;

            if (canvas_pro.width / canvas_pro.height > imgAspectRatio) {
                drawHeight = canvas_pro.height * scale;
                drawWidth = drawHeight * imgAspectRatio;
            } else {
                drawWidth = canvas_pro.width * scale;
                drawHeight = drawWidth / imgAspectRatio;
            }

            const offsetX = isMobileView() ? ((canvas_pro.width - drawWidth) / 2 + mobileOffsetX) : ((canvas_pro.width - drawWidth) / 2);
            const offsetY = isMobileView() ? ((canvas_pro.height - drawHeight) / 2 + mobileOffsetY) : ((canvas_pro.height - drawHeight) / 2);
            positionHotspots(drawWidth, drawHeight, offsetX, offsetY);
        }
    }

    drawImage(currentIndex_canvas);
}

function autoPlay(timestamp) {
    if (!isAutoPlaying || isTransitionPlaying) return;

    const deltaTime = timestamp - lastFrameTime;
    const frameInterval = 20 / viewer360SpeedFactor;
    if (deltaTime > frameInterval) {
        changeImage(autoPlayDirection, 1);
        lastFrameTime = timestamp - (deltaTime % frameInterval);
        accumulatedDrag *= 0.95;
        if (Math.abs(accumulatedDrag) < 0.1) {
            isAutoPlaying = false;
            drawImage(currentIndex_canvas);
        }
    }

    requestAnimationFrame(autoPlay);
}

function playTransitionSequence(sequence, sequenceKey, reverse = false, onComplete = null, holdLastFrame = false) {
    isTransitionPlaying = true;
    isReverseTransition = reverse;
    currentTransitionSequence = sequence;
    currentSequenceKey = sequenceKey;
    currentTransitionIndex = reverse ? sequence.totalImages - 1 : 0;
    transitionStartTime = performance.now();

    if (!reverse) {
        if (sequenceKey === 'hotspot-design') {
            activeFolderIndex = 0;
        } else if (sequenceKey === 'hotspot-dial') {
            activeFolderIndex = 1;
        } else if (sequenceKey === 'hotspot-bracelet') {
            activeFolderIndex = 2;
        } else if (sequenceKey === 'hotspot-movement') {
            activeFolderIndex = 0;
        }
    }

    if ((sequenceKey === 'hotspot-dial' || sequenceKey === 'hotspot-movement') && !reverse) {
        showOverlayText();
    }

    const baseFrameDuration = transitionFrameDurations[sequenceKey] || transitionFrameDurations['default'];
    const frameDuration = baseFrameDuration;

    if (!reverse && sequence.nextSequence) {
        const nextSequenceKey = sequence.nextSequence;
        const nextSequence = viewers[activeViewer].transitionSequences[nextSequenceKey];
        if (nextSequence && nextSequence.images.length < nextSequence.totalImages) {
            for (let i = 0; i < nextSequence.totalImages; i++) {
                if (!nextSequence.images[i]) {
                    const img = new Image();
                    const paddedIndex = i.toString().padStart(4, '0');
                    img.src = `${nextSequence.path}${paddedIndex}.png`;
                    img.onload = () => {
                        nextSequence.images[i] = img;
                    };
                    img.onerror = () => {
                        console.error(`Failed to preload next sequence image: ${img.src}`);
                    };
                }
            }
        }
    }

    function animateTransition(timestamp) {
        if (!isTransitionPlaying) {
            return;
        }

        const elapsed = timestamp - transitionStartTime;
        const totalDuration = sequence.totalImages * frameDuration;
        let progress = Math.min(elapsed / totalDuration, 1);

        let frameIndex;
        if (isReverseTransition) {
            frameIndex = Math.floor((1 - progress) * (sequence.totalImages - 1));
        } else {
            frameIndex = Math.floor(progress * (sequence.totalImages - 1));
        }

        if (progress >= 1) {
            isTransitionPlaying = false;
            isReverseTransition = false;

            if (!reverse && sequenceKey === 'hotspot-design' && sequence.nextSequence) {
                activeMicroSequence = 'design-turn-to-center';
                activeFolderIndex = 0;
                microSequenceIndex = 0;
                updateHotspots();
                drawImage(microSequenceIndex);
                updateDesignSliderThumb(0);
            } else if (!reverse && sequenceKey === 'hotspot-bracelet' && sequence.nextSequence) {
                activeMicroSequence = 'bracelet-micro-landscape';
                activeFolderIndex = 2;
                microSequenceIndex = 0;
                updateHotspots();
                drawImage(microSequenceIndex);
                updateBraceletSliderThumb(0);
            } else if (!reverse && sequenceKey === 'hotspot-dial' && sequence.nextSequence) {
                activeMicroSequence = 'dial-right-to-left';
                activeFolderIndex = 1;
                microSequenceIndex = 12;
                updateHotspots();
                drawImage(microSequenceIndex);
                updateDialSliderThumb(1 - (microSequenceIndex / (viewers[activeViewer].transitionSequences['dial-right-to-left'].images.length - 1)));
            } else if (!reverse && sequenceKey === 'hotspot-movement' && sequence.nextSequence) {
                activeMicroSequence = 'movementopen';
                activeFolderIndex = 0;
                microSequenceIndex = 0;
                updateHotspots();
                drawImage(microSequenceIndex);
            } else {
                currentSequenceKey = null;
                activeMicroSequence = null;
                hideOverlayText();
                updateHotspots();
                if (!holdLastFrame) {
                    drawImage(currentIndex_canvas);
                }
            }

            if (onComplete) {
                onComplete();
            }
            return;
        }

        currentTransitionIndex = frameIndex;
        drawImage(currentTransitionIndex, true, sequence, false, progress >= 0.98);
        requestAnimationFrame(animateTransition);
    }

    requestAnimationFrame(animateTransition);
}

function playLoopingAnimation(sequence, sequenceKey) {
    isLoopingAnimationPlaying = true;
    loopingSequenceKey = sequenceKey;
    currentTransitionSequence = sequence;
    currentSequenceKey = sequenceKey;
    loopingStartTime = performance.now();

    const frameDuration = transitionFrameDurations[sequenceKey] || transitionFrameDurations['default'];

    function animateLoop(timestamp) {
        if (!isLoopingAnimationPlaying) {
            return;
        }

        const elapsed = timestamp - loopingStartTime;
        const totalDuration = sequence.totalImages * frameDuration;
        const progress = (elapsed % totalDuration) / totalDuration;
        const frameIndex = Math.floor(progress * sequence.totalImages) % sequence.totalImages;

        drawImage(frameIndex, true, sequence, false, false);

        requestAnimationFrame(animateLoop);
    }

    requestAnimationFrame(animateLoop);
}

window.stopLoopingAnimation = function () {
    isLoopingAnimationPlaying = false;
    loopingSequenceKey = null;
    currentSequenceKey = null;
    drawImage(currentIndex_canvas);
};


let preHotspotFolderIndex = 0;
let preHotspotIndex = 0;

window.playTransitionForHotspot = function (hotspotId) {
    if (!isPreloadingComplete) {
        console.warn(`Cannot play transition for ${hotspotId}: Preloading not complete yet.`);
        return;
    }

    const sequence = viewers[activeViewer].transitionSequences[hotspotId];
    if (sequence) {
        const threeViewerMain = document.querySelector('.three-viewer-main');
        if (threeViewerMain) {
            threeViewerMain.classList.add('hidden');
        }

        preHotspotFolderIndex = activeFolderIndex;
        preHotspotIndex = currentIndex_canvas;

        if (isMobileView()) {
            const hotspotsToHide = [hotspotId];
            if (hotspotId === 'hotspot-bracelet') {
                hotspotsToHide.push('hotspot-movement');
            } else if (hotspotId === 'hotspot-movement') {
                hotspotsToHide.push('hotspot-design');
            }
            hotspotsToHide.forEach(hid => {
                const hotspot = document.getElementById(hid);
                if (hotspot) {
                    hotspot.classList.add('clicked');
                    hotspot.style.display = 'none';
                }
            });
        }

        if (hotspotId === 'hotspot-bracelet') {
            activeFolderIndex = 2;
            updateHotspots();
            activeMicroSequence = null;
            hideOverlayText();
            playTransitionSequence(sequence, hotspotId, false);
        } else if (hotspotId === 'hotspot-movement') {
            const designDetailElements = document.getElementsByClassName('design_detail_main');
            if (designDetailElements.length > 0) {
                for (let element of designDetailElements) {
                    element.style.display = 'none';
                }
            } else {
                console.warn('No elements with class design_detail_main found');
            }
            activeFolderIndex = 0;
            updateHotspots();
            activeMicroSequence = null;
            hideOverlayText();
            playTransitionSequence(sequence, hotspotId, false);
        } else if (hotspotId === 'hotspot-design') {
            activeFolderIndex = 0;
            updateHotspots();
            activeMicroSequence = null;
            hideOverlayText();
            playTransitionSequence(sequence, hotspotId, false);
        } else if (hotspotId === 'hotspot-dial') {
            activeFolderIndex = 2;
            updateHotspots();
            activeMicroSequence = null;
            hideOverlayText();
            playTransitionSequence(sequence, hotspotId, false);
        } else if (hotspotId === 'play-video') {
            activeFolderIndex = 1;
            updateHotspots();
            activeMicroSequence = null;
            hideOverlayText();
            playTransitionSequence(sequence, hotspotId, false);
        }
    }
};

window.playMovementAnimation = function () {
    const sequence = viewers[activeViewer].transitionSequences['movement-come'];
    if (sequence) {
        activeFolderIndex = 0;
        activeMicroSequence = null;
        hideOverlayText();
        updateHotspots();
        playTransitionSequence(sequence, 'movement-come', false);
    }
};

window.stopTransition = function () {
    const threeViewerMain = document.querySelector('.three-viewer-main');
    if (threeViewerMain) {
        threeViewerMain.classList.remove('hidden');
    }

    if (isMobileView()) {
    
        let lastActiveHotspot = null;
        if (currentSequenceKey === 'hotspot-design' || activeMicroSequence === 'design-turn-to-center') {
            lastActiveHotspot = 'hotspot-design';
        } else if (currentSequenceKey === 'hotspot-bracelet' || activeMicroSequence === 'bracelet-micro-landscape') {
            lastActiveHotspot = 'hotspot-bracelet';
        } else if (currentSequenceKey === 'hotspot-dial' || activeMicroSequence === 'dial-right-to-left') {
            lastActiveHotspot = 'hotspot-dial';
       
        } else if (currentSequenceKey === 'hotspot-movement' || activeMicroSequence === 'movementopen') {
            lastActiveHotspot = 'hotspot-movement';
        }

       
        const hotspotsToShow = [];
        if (lastActiveHotspot === 'hotspot-bracelet' || activeMicroSequence === 'bracelet-micro-landscape') {
            hotspotsToShow.push('hotspot-bracelet', 'hotspot-movement');
        } else if (lastActiveHotspot === 'hotspot-movement' || activeMicroSequence === 'movementopen') {
            hotspotsToShow.push('hotspot-movement');
            $('#hotspot-design').removeClass('clicked')
            setTimeout(() => {
                $('#hotspot-design').removeClass('active')
            }, 2000);
        } else if (lastActiveHotspot) {
            hotspotsToShow.push(lastActiveHotspot);
        }

     
        if (autoPlayDirection < 0 && lastActiveHotspot === 'hotspot-dial') {
            hotspotsToShow.length = 0; 
            hotspotsToShow.push('hotspot-dial');
        }

        hotspotsToShow.forEach(hid => {
            const hotspot = document.getElementById(hid);
            if (hotspot) {
                hotspot.classList.remove('clicked');
                hotspot.style.display = 'block';
                hotspot.style.opacity = '0';
                hotspot.style.transition = 'opacity 0.5s ease-in';
                setTimeout(() => {
                    hotspot.style.opacity = '1';
                }, 10);
                const pos = hotspotPositions[hid];
                if (pos) {
                    positionHotspots(pos.drawWidth, pos.drawHeight, pos.offsetX, pos.offsetY);
                    if (hid === 'hotspot-design') {
                        hotspot.style.bottom = `${pos.offsetY}%`;
                        hotspot.style.left = `${pos.left}%`;
                    } else if (hid === 'play-video') {
                        hotspot.style.bottom = `${pos.offsetY}%`;
                        hotspot.style.left = `${pos.left}%`;
                    } else if (hid === 'hotspot-bracelet') {
                        hotspot.style.bottom = `${pos.offsetY}%`;
                        hotspot.style.left = `${pos.left}%`;
                    } else if (hid === 'hotspot-movement') {
                        hotspot.style.bottom = `${pos.offsetY}%`;
                        hotspot.style.left = `${pos.left}%`;
                    }
                }
            }
        });

        if (currentSequenceKey === 'hotspot-design' || activeMicroSequence === 'design-turn-to-center') {
            const sequence = viewers[activeViewer].transitionSequences['hotspot-design'];
            if (sequence) {
                activeMicroSequence = null;
                activeFolderIndex = 0;
                playTransitionSequence(sequence, 'hotspot-design', true, () => {
                    const designHotspot = document.getElementById('hotspot-design');
                    if (designHotspot) {
                        designHotspot.style.display = 'block';
                        designHotspot.style.opacity = '0';
                        designHotspot.style.transition = 'opacity 0.5s ease-in';
                        setTimeout(() => {
                            designHotspot.style.opacity = '1';
                        }, 10);
                        const pos = hotspotPositions['hotspot-design'];
                        positionHotspots(pos.drawWidth, pos.drawHeight, pos.offsetX, pos.offsetY);
                        designHotspot.style.bottom = `${pos.offsetY}%`;
                        designHotspot.style.left = `${pos.left}%`;
                    }
                });
            }
        } else if (currentSequenceKey === 'hotspot-bracelet' || activeMicroSequence === 'bracelet-micro-landscape') {
            const sequence = viewers[activeViewer].transitionSequences['hotspot-bracelet'];
            if (sequence) {
                activeMicroSequence = null;
                activeFolderIndex = 4;
                playTransitionSequence(sequence, 'hotspot-bracelet', true, () => {
                    const braceletHotspot = document.getElementById('hotspot-bracelet');
                    if (braceletHotspot) {
                        braceletHotspot.style.display = 'block';
                        braceletHotspot.style.opacity = '0';
                        braceletHotspot.style.transition = 'opacity 0.5s ease-in';
                        setTimeout(() => {
                            braceletHotspot.style.opacity = '1';
                            const pos = hotspotPositions['hotspot-bracelet'];
                            positionHotspots(pos.drawWidth, pos.drawHeight, pos.offsetX, pos.offsetY);
                            braceletHotspot.style.bottom = `${pos.offsetY}%`;
                            braceletHotspot.style.left = `${pos.left}%`;
                        }, 10);
                    }
                    const movementHotspot = document.getElementById('hotspot-movement');
                    if (movementHotspot) {
                        movementHotspot.style.display = 'block';
                        movementHotspot.style.opacity = '0';
                        movementHotspot.style.transition = 'opacity 0.5s ease-in';
                        setTimeout(() => {
                            movementHotspot.style.opacity = '1';
                        }, 10);
                        const pos = hotspotPositions['hotspot-movement'];
                        positionHotspots(pos.drawWidth, pos.drawHeight, pos.offsetX, pos.offsetY);
                        movementHotspot.style.bottom = `${pos.offsetY}%`;
                        movementHotspot.style.left = `${pos.left}%`;
                    }
                });
            }
        
        } else if (currentSequenceKey === 'hotspot-dial' || activeMicroSequence === 'dial-right-to-left') {
            const sequence = viewers[activeViewer].transitionSequences['hotspot-dial'];
            if (sequence) {
                activeMicroSequence = null;
                activeFolderIndex = 2;
                playTransitionSequence(sequence, 'hotspot-dial', true, () => {
                    const dialHotspot = document.getElementById('hotspot-dial');
                    if (dialHotspot) {
                        dialHotspot.style.display = 'block';
                        dialHotspot.style.opacity = '0';
                        dialHotspot.style.transition = 'opacity 0.5s ease-in';
                        setTimeout(() => {
                            dialHotspot.style.opacity = '1';
                        }, 10);
                        const pos = hotspotPositions['hotspot-dial'];
                        positionHotspots(pos.drawWidth, pos.drawHeight, pos.offsetX, pos.offsetY);
                    }
                });
            }
        } else if (currentSequenceKey === 'hotspot-movement' || activeMicroSequence === 'movementopen') {
            const sequence = viewers[activeViewer].transitionSequences['hotspot-movement'];
            if (sequence) {
                activeMicroSequence = null;
                activeFolderIndex = 0;
                playTransitionSequence(sequence, 'hotspot-movement', true, () => {
                    const movementHotspot = document.getElementById('hotspot-movement');
                    if (movementHotspot) {
                        movementHotspot.style.display = 'block';
                        movementHotspot.style.opacity = '0';
                        movementHotspot.style.transition = 'opacity 0.5s ease-in';
                        setTimeout(() => {
                            movementHotspot.style.opacity = '1';
                        }, 10);
                        const pos = hotspotPositions['hotspot-movement'];
                        positionHotspots(pos.drawWidth, pos.drawHeight, pos.offsetX, pos.offsetY);
                    }
                    const designHotspot = document.getElementById('hotspot-design');
                    if (designHotspot) {
                        designHotspot.style.display = 'block';
                        designHotspot.style.opacity = '0';
                        designHotspot.style.transition = 'opacity 0.5s ease-in';
                        setTimeout(() => {
                            designHotspot.style.opacity = '1';
                        }, 10);
                        const posDesign = hotspotPositions['hotspot-design'];
                        positionHotspots(posDesign.drawWidth, posDesign.drawHeight, posDesign.offsetX, posDesign.offsetY);
                        designHotspot.style.bottom = `${posDesign.offsetY}%`;
                        designHotspot.style.left = `${posDesign.left}%`;
                    }
                });
            }
        } else {
            isTransitionPlaying = false;
            isReverseTransition = false;
            activeMicroSequence = null;
            currentSequenceKey = null;
            updateHotspots();
            hideOverlayText();
            drawImage(currentIndex_canvas);
        }

        if (autoPlayDirection < 0 && document.getElementById('hotspot-dial').classList.contains('active')) {
            const designHotspot = document.getElementById('hotspot-design');
            if (designHotspot) {
                designHotspot.classList.remove('active');
            }
        }
    } else {
        if (currentSequenceKey === 'hotspot-design' || activeMicroSequence === 'design-turn-to-center') {
            const sequence = viewers[activeViewer].transitionSequences['hotspot-design'];
            if (sequence) {
                activeMicroSequence = null;
                activeFolderIndex = 0;
                playTransitionSequence(sequence, 'hotspot-design', true);
            }
        } else if (currentSequenceKey === 'hotspot-bracelet' || activeMicroSequence === 'bracelet-micro-landscape') {
            const sequence = viewers[activeViewer].transitionSequences['hotspot-bracelet'];
            if (sequence) {
                activeMicroSequence = null;
                activeFolderIndex = 3;
                playTransitionSequence(sequence, 'hotspot-bracelet', true);
            }
        } else if (currentSequenceKey === 'hotspot-dial' || activeMicroSequence === 'dial-right-to-left') {
            const sequence = viewers[activeViewer].transitionSequences['hotspot-dial'];
            if (sequence) {
                activeMicroSequence = null;
                activeFolderIndex = 1;
                playTransitionSequence(sequence, 'hotspot-dial', true);
            }
    
        } else if (currentSequenceKey === 'hotspot-movement' || activeMicroSequence === 'movementopen') {
            const sequence = viewers[activeViewer].transitionSequences['hotspot-movement'];
            if (sequence) {
                activeMicroSequence = null;
                activeFolderIndex = 0;
                playTransitionSequence(sequence, 'hotspot-movement', true);
            }
        } else {
            isTransitionPlaying = false;
            isReverseTransition = false;
            activeMicroSequence = null;
            currentSequenceKey = null;
            updateHotspots();
            hideOverlayText();
            drawImage(currentIndex_canvas);
        }
    }
};

window.updateMicroSequenceIndex = function(hotspotId, percentage) {
    if (!activeMicroSequence) return;

    const sequence = viewers[activeViewer].transitionSequences[activeMicroSequence];
    if (!sequence) {
        console.error(`Sequence ${activeMicroSequence} not found for viewer ${activeViewer}`);
        return;
    }

    const totalFrames = sequence.images.length;
    let index;
    if (activeMicroSequence === 'dial-right-to-left') {
        index = Math.round((1 - percentage) * (totalFrames - 1));
    } else {
        index = Math.round(percentage * (totalFrames - 1));
    }
    microSequenceIndex = Math.max(0, Math.min(totalFrames - 1, index));
    drawImage(microSequenceIndex);

   
    if (activeMicroSequence === 'design-turn-to-center') {
        updateDesignSliderThumb(percentage);
    } else if (activeMicroSequence === 'dial-right-to-left') {
        updateDialSliderThumb(percentage);
    } else if (activeMicroSequence === 'bracelet-micro-landscape') {
        updateBraceletSliderThumb(percentage);
    } else if (activeMicroSequence === 'movementopen') {
      
        const thumb = document.getElementById('movement-thumb');
        if (thumb) {
            const point = getPointAlongPath('movement-curve', percentage);
            thumb.style.left = `${point.x}px`;
            thumb.style.top = `${point.y}px`;
        }
    }

    const slideBg = document.querySelector('.slide-bg');
    if (slideBg && microSequenceIndex > 0 && microSequenceIndex < totalFrames - 1) {
        const maxBgPosition = bgPositionConfig[activeMicroSequence] || 10;
        let bgPosition;
        if (activeMicroSequence === 'dial-right-to-left') {
            bgPosition = ((totalFrames - 1 - microSequenceIndex) / (totalFrames - 1)) * maxBgPosition;
            slideBg.style.backgroundPosition = `-${bgPosition}px center`;
        } else {
            bgPosition = (microSequenceIndex / (totalFrames - 1)) * maxBgPosition;
            slideBg.style.backgroundPosition = `center -${bgPosition}px`;
        }
    }
};

window.startSliderAutoPlay = function (hotspotId, dragDirection) {
    if (activeMicroSequence && !isTransitionPlaying && !isLoopingAnimationPlaying) {
        sliderAutoPlayDirection = dragDirection;
        isSliderAutoPlaying = true;
        sliderAutoPlayStartTime = performance.now();
        requestAnimationFrame(autoPlaySlider);
    }
}

function autoPlaySlider(timestamp) {
    if (!isSliderAutoPlaying) {
        return;
    }

    const elapsed = timestamp - sliderAutoPlayStartTime;
    const totalDuration = sliderAutoPlayDuration;
    const progress = Math.min(elapsed / totalDuration, 1);

    if (!viewers[activeViewer].transitionSequences || !viewers[activeViewer].transitionSequences[activeMicroSequence]) {
        console.error(`Sequence ${activeMicroSequence} is not defined in autoPlaySlider for viewer ${activeViewer}`);
        isSliderAutoPlaying = false;
        activeMicroSequence = null;
        drawImage(currentIndex_canvas);
        return;
    }

    const totalFrames = viewers[activeViewer].transitionSequences[activeMicroSequence].images.length;
    let targetIndex;
    if (activeMicroSequence === 'dial-right-to-left') {
        if (sliderAutoPlayDirection === 1) {
            targetIndex = 0;
        } else {
            targetIndex = totalFrames - 1;
        }
    } else {
        if (sliderAutoPlayDirection === 1) {
            targetIndex = totalFrames - 1;
        } else {
            targetIndex = 0;
        }
    }

    const startIndex = microSequenceIndex;
    const currentIndex = Math.round(startIndex + (targetIndex - startIndex) * progress);
    microSequenceIndex = Math.max(0, Math.min(totalFrames - 1, currentIndex));
    drawImage(microSequenceIndex);

    if (activeMicroSequence === 'design-turn-to-center') {
        const thumbProgress = microSequenceIndex / (totalFrames - 1);
        updateDesignSliderThumb(thumbProgress);
    } else if (activeMicroSequence === 'dial-right-to-left') {
        const thumbProgress = (totalFrames - 1 - microSequenceIndex) / (totalFrames - 1);
        updateDialSliderThumb(thumbProgress);
    } else if (activeMicroSequence === 'bracelet-micro-landscape') {
        const thumbProgress = microSequenceIndex / (totalFrames - 1);
        updateBraceletSliderThumb(thumbProgress);
    }

    if (['design-turn-to-center', 'dial-right-to-left', 'bracelet-micro-landscape', 'movementopen'].includes(activeMicroSequence)) {
        const slideBg = document.querySelector('.slide-bg');
        if (slideBg && microSequenceIndex > 0 && microSequenceIndex < totalFrames - 1) {
            const maxBgPosition = bgPositionConfig[activeMicroSequence];
            let bgPosition;
            if (activeMicroSequence === 'dial-right-to-left') {
                bgPosition = ((totalFrames - 1 - microSequenceIndex) / (totalFrames - 1)) * maxBgPosition;
                slideBg.style.backgroundPosition = `-${bgPosition}px center`;
            } else {
                bgPosition = (microSequenceIndex / (totalFrames - 1)) * maxBgPosition;
                slideBg.style.backgroundPosition = `center -${bgPosition}px`;
            }
        }
    }

    if (progress >= 1) {
        isSliderAutoPlaying = false;
        return;
    } else {
        requestAnimationFrame(autoPlaySlider);
    }
}

function adjustCanvasSize() {
    canvas_pro.width = window.innerWidth;
    canvas_pro.height = window.innerHeight;
    drawImage(currentIndex_canvas);

    const headingElement = document.getElementById('overlay-heading');
    const textElement = document.getElementById('overlay-text');
    if (headingElement && headingElement.style.display === 'block') {
        headingElement.style.left = isMobileView() ? '50%' : '60%';
        headingElement.style.top = isMobileView() ? '35%' : '40%';
    }
    if (textElement && textElement.style.display === 'block') {
        textElement.style.left = isMobileView() ? '50%' : '60%';
        textElement.style.top = isMobileView() ? '45%' : '50%';
        textElement.style.width = isMobileView() ? '45%' : '35%';
    }
}

window.switchViewer = function(viewerKey) {
    if (!viewers[viewerKey]) {
        console.error(`Viewer ${viewerKey} not initialized`);
        return;
    }

    document.querySelector('.three-viewer-main .active')?.classList.remove('active');
    
    const activeButton = document.querySelector(`.three-viewer-main .${viewerKey}`);
    if (activeButton) {
        activeButton.classList.add('active');
    }

    activeViewer = viewerKey;

    preloadImages(activeViewer).then(() => {
        currentIndex_canvas = 0;
        microSequenceIndex = 0; 
        drawImage(currentIndex_canvas); 
        updateHotspots(); 
    }).catch(error => {
        console.error(`Error preloading images for ${viewerKey}:`, error);
    });
};

window.changeImage = changeImage;

document.addEventListener('DOMContentLoaded', () => {
    initBraceletSound();
    let lastActiveHotspot = null;
    const hotspotsContainer = document.querySelector('.hotspots');
    const hideHotspots = () => {
        if (hotspotsContainer) {
            hotspotsContainer.style.display = 'none';
        }
    };

    const updateAndHideHotspots = (hotspotId) => {
        lastActiveHotspot = hotspotId;
        if (hotspotsContainer) {
            const currentActive = document.querySelector('.hotspot.active');
            if (currentActive && currentActive.id !== lastActiveHotspot) {
                currentActive.classList.remove('active');
            }
            document.getElementById(lastActiveHotspot).classList.add('active');
            hotspotsContainer.style.display = 'none';
        }
    };

    document.getElementById('hotspot-design').addEventListener('click', () => {
        updateAndHideHotspots('hotspot-design');
        window.playTransitionForHotspot('hotspot-design');
    });
    document.getElementById('hotspot-dial').addEventListener('click', () => {
        updateAndHideHotspots('hotspot-dial');
        window.playTransitionForHotspot('hotspot-dial');
    });
    document.getElementById('hotspot-bracelet').addEventListener('click', () => {
        updateAndHideHotspots('hotspot-bracelet');
        window.playTransitionForHotspot('hotspot-bracelet');
    });
    document.getElementById('hotspot-movement').addEventListener('click', () => {
        updateAndHideHotspots('hotspot-movement');
        window.playTransitionForHotspot('hotspot-movement');
    });
    document.getElementById('play-video').addEventListener('click', () => {
        updateAndHideHotspots('play-video');
        showVideoPopup();
    });


    document.addEventListener('DOMContentLoaded', () => {
        const video = document.querySelector('.popup-video');
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
       
    });

    const playVideoHotspot = document.querySelector('#play-video');
    if (playVideoHotspot) {
        playVideoHotspot.addEventListener('click', showVideoPopup);
    }

    const closeVideoBtn = document.querySelector('.close-video-btn');
    if (closeVideoBtn) {
        closeVideoBtn.addEventListener('click', hideVideoPopup);
    }


    window.initializeDynamicViewers();

    document.querySelector('.three-viewer-main').addEventListener('click', (e) => {
        const button = e.target.closest('button');
        if (button) {
            const viewerKey = Array.from(button.classList).find(cls => cls.startsWith('viewer-'));
            if (viewerKey) {
                window.switchViewer(viewerKey);
            }
        }
    });

    const movementSlider = document.getElementById('slider');
    const braceletSlider = document.getElementById('bracelet-slider');
    const hotspotTitle = document.querySelector('.hotspot-title');
    const hotspotDescription = document.querySelector('.hotspot-description');

    function setupSlider(slider, sequenceKey) {
        if (slider && hotspotTitle && hotspotDescription) {
            let isAutoDragging = false;
            let autoDragStartTime = 0;
            let initialValue = 0;
            let isManualDragging = false;
            let dragDirection = 0;
            let previousValue = 0;

            slider.addEventListener('input', (e) => {
                const currentValue = parseInt(e.target.value);
                const dragProgress = currentValue / 100;
                hotspotTitle.style.opacity = 1;
                hotspotDescription.style.opacity = 1;

                if (activeMicroSequence === sequenceKey) {
                    const totalFrames = viewers[activeViewer].transitionSequences[sequenceKey].images.length;
                    const newIndex = Math.round(dragProgress * (totalFrames - 1));
                    microSequenceIndex = newIndex;
                    drawImage(microSequenceIndex);

                    if (sequenceKey === 'bracelet-micro-landscape') {
                        window.updateMicroSequenceIndex('hotspot-bracelet', dragProgress);
                    }
                }

                if (currentValue !== previousValue) {
                    if (currentValue > previousValue) dragDirection = 1;
                    else if (currentValue < previousValue) dragDirection = -1;

                    if (!isAutoDragging && (currentValue > 0 || currentValue < 100)) {
                        isAutoDragging = true;
                        initialValue = currentValue;
                        autoDragStartTime = performance.now();
                        requestAnimationFrame((timestamp) => autoDragAnimation(timestamp, sequenceKey));
                    }
                }
                previousValue = currentValue;
            });

            slider.addEventListener('mousedown', () => { isManualDragging = true; previousValue = parseInt(slider.value); });
            slider.addEventListener('touchstart', () => { isManualDragging = true; previousValue = parseInt(slider.value); });
            slider.addEventListener('mouseup', () => { isManualDragging = false; if (!isAutoDragging && parseInt(slider.value) < 5) resetSlider(slider, sequenceKey); });
            slider.addEventListener('touchend', () => { isManualDragging = false; if (!isAutoDragging && parseInt(slider.value) < 5) resetSlider(slider, sequenceKey); });

            function resetSlider(slider, sequenceKey) {
                slider.value = 0;
                hotspotTitle.style.opacity = 1;
                hotspotDescription.style.opacity = 1;
                if (activeMicroSequence === sequenceKey) {
                    microSequenceIndex = 0;
                    drawImage(microSequenceIndex);
                    if (sequenceKey === 'bracelet-micro-landscape') {
                        window.updateMicroSequenceIndex('hotspot-bracelet', 0);
                    }
                }
            }

            function autoDragAnimation(timestamp, seqKey) {
                if (!isAutoDragging || activeMicroSequence !== seqKey) {
                    isAutoDragging = false;
                    return;
                }
                const elapsed = timestamp - autoDragStartTime;
                const totalDuration = 1000;
                const progress = Math.min(elapsed / totalDuration, 1);
                const easedProgress = dragDirection === 1 ? progress : 1 - Math.pow(1 - progress, 2);
                let targetValue = dragDirection === 1 ? Math.round(initialValue + (100 - initialValue) * easedProgress) : Math.round(initialValue - initialValue * easedProgress);
                targetValue = Math.max(0, Math.min(100, targetValue));
                slider.value = targetValue;
                const dragProgress = slider.value / 100;
                hotspotTitle.style.opacity = 1;
                hotspotDescription.style.opacity = 1;
                if (activeMicroSequence === seqKey) {
                    const totalFrames = viewers[activeViewer].transitionSequences[seqKey].images.length;
                    microSequenceIndex = Math.round(dragProgress * (totalFrames - 1));
                    drawImage(microSequenceIndex);
                    if (seqKey === 'bracelet-micro-landscape') {
                        window.updateMicroSequenceIndex('hotspot-bracelet', dragProgress);
                    }
                }
                if (progress < 1) requestAnimationFrame((timestamp) => autoDragAnimation(timestamp, seqKey));
                else isAutoDragging = false;
            }
        }
    }

    if (movementSlider) setupSlider(movementSlider, 'movementopen');
    if (braceletSlider) setupSlider(braceletSlider, 'bracelet-micro-landscape');

    const closeFocusBtn = document.querySelector('.close-focus-btn');
    if (closeFocusBtn) {
        closeFocusBtn.addEventListener('click', () => {
            isAutoDragging = false;
            isSliderAutoPlaying = false;
            const wasReverse = autoPlayDirection < 0;
            autoPlayDirection = 0;
            if (movementSlider) movementSlider.value = 0;
            if (braceletSlider) braceletSlider.value = 0;
            hotspotTitle.style.opacity = 1;
            hotspotDescription.style.opacity = 1;

            let targetIndex = 0;
            if (activeMicroSequence) {
                const totalMicroFrames = viewers[activeViewer].transitionSequences[activeMicroSequence].images.length;
                targetIndex = totalMicroFrames - 1;
                if (activeMicroSequence === 'bracelet-micro-landscape') {
                    activeFolderIndex = 2;
                    targetIndex = 15;
                } else if (activeMicroSequence === 'movementopen') {
                    activeFolderIndex = 1;
                } else if (activeMicroSequence === 'dial-right-to-left') {
                    activeFolderIndex = 0;
                } else if (activeMicroSequence === 'design-turn-to-center') {
                    activeFolderIndex = 3;
                }
            } else if (wasReverse && !activeMicroSequence) {
                targetIndex = viewers[activeViewer].folders[activeFolderIndex].images.length - 1;
            } else {
                targetIndex = 0;
            }
            microSequenceIndex = targetIndex;
            drawImage(microSequenceIndex);

            if (activeMicroSequence) {
                const activeHotspot = document.querySelector('.hotspot.active')?.id || lastActiveHotspot;
                if (activeHotspot) {
                    const transitionSequence = viewers[activeViewer].transitionSequences[activeHotspot];
                    if (transitionSequence) {
                        activeMicroSequence = null;
                        const reverseIndex = transitionSequence.totalImages - 1;
                        playTransitionSequence(transitionSequence, activeHotspot, true, () => {
                            if ((wasReverse || !wasReverse) && activeHotspot === 'hotspot-bracelet') {

                                const folder4 = viewers[activeViewer]?.folders?.[3];
                                const lastFrame = folder4 ? (folder4.totalImages - 1) : 0;

                                activeFolderIndex = 3;
                                currentIndex_canvas = lastFrame;
                                microSequenceIndex = lastFrame;
                                
                                drawImage(currentIndex_canvas, false, null, false, false, activeFolderIndex);
                            } else {
                                if (activeHotspot === 'hotspot-dial') activeFolderIndex = 1;
                                else if (activeHotspot === 'hotspot-movement') activeFolderIndex = 2;
                                else if (activeHotspot === 'hotspot-design') activeFolderIndex = 4;
                                const lastIndex = viewers[activeViewer].folders[activeFolderIndex].images.length - 1;
                                currentIndex_canvas = lastIndex;
                                microSequenceIndex = lastIndex;
                                drawImage(currentIndex_canvas, false, null, false, false, activeFolderIndex);
                            }
                            if (hotspotsContainer) {
                                hotspotsContainer.style.display = 'block';
                                const hotspots = hotspotsContainer.querySelectorAll('.hotspot');
                                hotspots.forEach(hotspot => {
                                    hotspot.style.opacity = '0';
                                    hotspot.style.transition = 'opacity 0.5s ease-in';
                                    setTimeout(() => {
                                        hotspot.style.opacity = '1';
                                    }, 10);
                                });
                                const lastActiveElement = document.getElementById(lastActiveHotspot);
                                if (lastActiveElement) {
                                    lastActiveElement.classList.add('active');
                                }
                            }
                        }, true);
                    }
                }
            } else {
                activeMicroSequence = null;
                window.stopTransition();
                if (hotspotsContainer) {
                    hotspotsContainer.style.display = 'block';
                    const hotspots = hotspotsContainer.querySelectorAll('.hotspot');
                    hotspots.forEach(hotspot => {
                        hotspot.style.opacity = '0';
                        hotspot.style.transition = 'opacity 0.5s ease-in';
                        setTimeout(() => {
                            hotspot.style.opacity = '1';
                        }, 10);
                    });
                    const lastActiveElement = document.getElementById(lastActiveHotspot);
                    if (lastActiveElement) {
                        lastActiveElement.classList.add('active');
                    }
                }
            }

            const designSlider = document.getElementById('design-slider');
            const dialSlider = document.getElementById('dial-slider');
            if (designSlider) designSlider.style.display = 'none';
            if (dialSlider) dialSlider.style.display = 'none';
            if (braceletSlider) braceletSlider.style.display = 'none';
        });
    }

    window.addEventListener('resize', adjustCanvasSize);
    adjustCanvasSize();
});


